import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as DocumentFieldsActions from './documentfields.actions';
import * as DocumentFieldsSelectors from './documentfields.selectors';
import { Observable, map } from 'rxjs';
import { IMetadataItemDto } from '../metadata-item.dto';

@Injectable({ providedIn: 'root' })
export class DocumentFieldsFacade {
  documentFields$ = this.store.select(DocumentFieldsSelectors.selectAllDocumentFields);
  loading$ = this.store.select(DocumentFieldsSelectors.selectDocumentFieldsLoading);
  error$ = this.store.select(DocumentFieldsSelectors.selectDocumentFieldsError);
  contactFields$ = this.store.select(DocumentFieldsSelectors.selectAllContactFields);
  contactLoading$ = this.store.select(DocumentFieldsSelectors.selectContactFieldsLoading);
  contactError$ = this.store.select(DocumentFieldsSelectors.selectContactFieldsError);
  contactFieldsStale$ = this.store.select(DocumentFieldsSelectors.selectContactFieldsStale);

  constructor(private store: Store) {}

  loadDocumentFields(page: number) {
    this.store.dispatch(DocumentFieldsActions.loadDocumentFields({ page }));
  }

  // pass one or multiple types
  getFieldsByType(types: string[]): Observable<IMetadataItemDto[]> {
    return this.documentFields$.pipe(
      map(fields => fields.filter(f => types.includes(f.meta_data_type)))
    );
  }

  loadContactFields() {
    this.store.dispatch(DocumentFieldsActions.loadContactFields());
  }

  updateContactFields() {
    this.store.dispatch(DocumentFieldsActions.updateContactFields());
  }
}
